export const DataHooks = {
  Title: 'PaymentMethod.Title',
  PrimaryMark: 'PaymentMethod.PrimaryMark',
} as const;
